export const tierQuizData = [
    {
        id: 'tier-q1',
        question: 'How Important is Skincare to you?',
        weight: 1,
        answers: [
            {
                id: 'tier-q1a1',
                category: 0,
                body: "Not that important, it's just something I do to prevent wrinkles and breakouts",
            },
            {
                id: 'tier-q1a2',
                category: 1,
                body: "It's part of my routine - it's a natural part of my day and it keeps me looking good!",
            },
            {
                id: 'tier-q1a3',
                category: 2,
                body: 'Skincare is Life! I love using products, and I look forward to my skincare ritual; on Wednesdays we exfoliate!',
            },
        ]
    },
    {
        id: 'tier-q2',
        question: 'How long is your routine?',
        weight: 1,
        answers: [
            {
                id: 'tier-q2a1',
                category: 0,
                body: 'A couple of minutes when I remember'
            },
            {
                id: 'tier-q2a2',
                category: 1,
                body: '5-10 minutes everyday',
            },
            {
                id: 'tier-q2a3',
                category: 2,
                body: 'Anywhere from 10 minutes to 30 mins+ depending on what the plan is the day'
            }
        ]
    },
    {
        id: 'tier-q3',
        question: 'How many skincare products do you currently have and use?',
        weight: 1,
        answers: [
            {
                id: 'tier-q3a1',
                category: 0,
                body: '1-2 tried and true. My staples'
            },
            {
                id: 'tier-q3a2',
                category: 1,
                body: 'I have 3-4 skincare products, not including my cleanser and I\'m thinking about getting a small skincare fridge when it\'s on sale.',
            },
            {
                id: 'tier-q3a3',
                category: 2,
                body: 'My house could be converted into a spa in a pinch. My shelfie game is strong, and they are used on rotation'
            }
        ]
    }
];
export const productQuizData = [
    {
        id: 'prod-q1',
        pointedQuestion: false,
        imageQuestion: true,
        weight: 2,
        question: 'What skintone is most like yours, gorgeous?',
        answers: [
            {
                id: 'prod-q1a1',
                categories: [0],
                description: 'Very pale skintone'
            },
            {
                id: 'prod-q1a2',
                categories: [1],
                description: 'Pale skintone'
            },
            {
                id: 'prod-q1a3',
                categories: [2],
                description: 'Medium skintone'
            },
            {
                id: 'prod-q1a4',
                categories: [3],
                description: 'Brown skintone'
            },
            {
                id: 'prod-q1a5',
                categories: [4],
                description: 'Dark skintone'
            },
            {
                id: 'prod-q1a6',
                categories: [5],
                description: 'Very dark skintone'
            },
        ]
    },
    {
        id: 'prod-q2',
        pointedQuestion: true,
        weight: -1,
        question: 'What\'s your favorite thing about your skin?',
        answers: [
            {
                id: 'prod-q2a1',
                categories: [0],
                body: 'I rarely ever break out'
            },
            {
                id: 'prod-q2a2',
                categories: [1],
                body: 'People think I look younger than I am'
            },
            {
                id: 'prod-q2a3',
                categories: [2, 5],
                body: 'My skin is always soft and naturally dewy'
            },
            {
                id: 'prod-q2a4',
                categories: [3],
                body: 'I have the best, most even skin tone'
            },
            {
                id: 'prod-q2a5',
                categories: [4],
                body: 'Most days, I really feel like my skin is perfect'
            },
        ]
    },
    {
        id: 'prod-q3',
        pointedQuestion: true,
        weight: 1,
        question: 'What\'s one of your big skin fears?',
        answers: [
            {
                id: 'prod-q3a1',
                categories: [0, 4],
                body: 'I\'m worried about getting wrinkles'
            },
            {
                id: 'prod-q3a2',
                categories: [0],
                body: 'I go to bed worrying if I\'m going to wake up with a face full of zits'
            },
            {
                id: 'prod-q3a3',
                categories: [1],
                body: 'I\'m afraid of getting a lot of acne scars/darkspots that won\'t heal or go away'
            },
            {
                id: 'prod-q3a4',
                categories: [2, 5],
                body: 'That those years of tanning will give me skin cancer'
            },
            {
                id: 'prod-q3a5',
                categories: [3],
                body: 'That I\'ll develop a skin condition that runs in my family'
            },
            {
                id: 'prod-q3a6',
                categories: [3],
                body: 'That my skin becomes dry, crepey, and itchy'
            },
            {
                id: 'prod-q3a7',
                categories: [4],
                body: 'My skin gets dry, bumpy, and flaky'
            },
            {
                id: 'prod-q3a8',
                categories: [4],
                body: 'I feel like I\'m getting wrinkles faster than my friends'
            },
        ]
    },
    {
        id: 'prod-q4',
        pointedQuestion: true,
        weight: 1,
        question: 'What\'s one of your big skin hopes?',
        answers: [
            {
                id: 'prod-q4a1',
                categories: [0],
                body: 'That my skin will one day clear and I will never again even think about a zit'
            },
            {
                id: 'prod-q4a2',
                categories: [1, 4],
                body: 'That I, and I alone, will never have wrinkles and will be baby skin smooth forever'
            },
            {
                id: 'prod-q4a3',
                categories: [2, 5],
                body: 'That I just won\'t have to worry about my skin, and that I can actually do any skincare routine I want without worrying about how my skin will react'
            },
            {
                id: 'prod-q4a4',
                categories: [3],
                body: 'That my skin will be dewy, and glass, and perfect. And I will be the envy of all of the skin models'
            },
        ]
    },
    {
        id: 'prod-q5',
        pointedQuestion: true,
        weight: 1,
        question: 'What\'s your skin type?',
        answers: [
            {
                id: 'prod-q5a1',
                categories: [0, 3, 5],
                body: 'Dry'
            },
            {
                id: 'prod-q5a2',
                categories: [0, 1, 2, 3, 4, 5],
                body: 'Normal'
            },
            {
                id: 'prod-q5a3',
                categories: [3, 4, 5],
                body: 'Combination'
            },
            {
                id: 'prod-q5a4',
                categories: [4, 1, 0],
                body: 'Oily'
            },
            {
                id: 'prod-q5a5',
                categories: [0, 1, 2, 3, 4, 5],
                body: 'Mature'
            },
            {
                id: 'prod-q5a6',
                categories: [3],
                body: 'Sensitive'
            },
        ]
    },
];
const extraQuestionData = [
    {
        id: 'extra-q1',
        question: 'Would you say you\'re under a lot of stress?',
        answers: [
            {
                id: 'extra-q1a1',
                responseKey: 'high',
                response: '*Deep breath* ... Yes.',
                feedback: 'It doesn\'t help to tell someone to stop being so stressed, but, if you haven\'t been told to do so already, maybe you want to see a therapist about it? Life has the potential to be really stressful, and many of our responsbilities and the image we\'ve built for ourselves make it tough to take care of ourselves properly sometimes. Take time for you, no one else is going to do it in the long term. Please remember to forgive yourself, and your breakouts for popping up when you\'re under a lot of stress. It\'s normal, and it\'s your body telling you that it\'s worried about you. <3'
            },
            {
                id: 'extra-q1a2',
                responseKey: 'medium',
                response: 'I get stressed sometimes, but doesn\'t everybody?',
                feedback: 'Yeah, life is stressful sometimes; it\'s not always rainbows and butterflies. We wish it was, and we know our skin does, too. But, as long as we remember to take care of ourselves during and after the stressful times, things are sure to work out! You got this, love!'
            },
            {
                id: 'extra-q1a3',
                responseKey: 'low',
                response: 'I\'m stress-free and zen 24/7',
                feedback: 'Teach us your ways, pleeasse!! Is it meditation? Is long walks on the beach with your dog? Either way, way to go! Your skin must love you!'
            }
        ]
    }
];
// Below are questions that were originally part of the quiz but removed. Saved here just in case.
// {
//   id: 2,
//   question: 'Do you ever miss a day of doing your skincare routine? If so, how often?',
//   weight: 2,
//   answers: [
//     {
//       category: 0,
//       body: 'I\'m lucky if I remember'
//     },
//     {
//       category: 1,
//       body: 'I usually do it, but if I miss a day I don\'t worry about it.',
//     },
//     {
//       category: 2,
//       body: 'I never miss a day! How dare you!'
//     }
//   ]
// },
// {
//   id: 5,
//   question: 'How do you find out about Skincare?',
//   weight: 1,
//   answers: [
//     {
//       category: 0,
//       body: 'From a friend or an ad'
//     },
//     {
//       category: 1,
//       body: 'Social Media and Buzzfeed Articles',
//     },
//     {
//       category: 2,
//       body: 'I\'m an active member in skincare subreddits, and my youtube may or may not be curated for skincare'
//     }
//   ]
// },
// {
//   id: 3,
//   pointedQuestion: true,
//   weight: 1,
//   question: 'What\'s your least favorite thing about your skin?',
//   answers: [
//     {
//       categories: [0],
//       body: 'I break out so easily!'
//     },
//     {
//       categories: [0, 4],
//       body: 'My skin is so oily!'
//     },
//     {
//       categories: [1],
//       body: 'I get darkspots and I don\'t even pop my pimples'
//     },
//     {
//       categories: [1],
//       body: 'My skintone is so uneven'
//     },
//     {
//       categories: [2, 3, 5],
//       body: 'Everything makes my skin irritated'
//     },
//     {
//       categories: [3],
//       body: 'I wake up and my skin is red!'
//     },
//     {
//       categories: [4],
//       body: 'My skin gets dry, bumpy, and flaky'
//     },
//     {
//       categories: [4],
//       body: 'I feel like I\'m getting wrinkles faster than my friends'
//     },
//   ]
// },
